import { render, staticRenderFns } from "./loan-comparing-tool.vue?vue&type=template&id=99b24556"
import script from "./loan-comparing-tool.vue?vue&type=script&lang=js"
export * from "./loan-comparing-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports